import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import './Christening.css';
import { Link } from 'react-router-dom';

function Christening() {
  const [selectedImage, setSelectedImage] = useState(null);
  const images = [
    { src: "/images/Dbotez/Christening-2.jpg", alt: "Christening 1" },
    { src: "/images/Dbotez/Christening-3.jpg", alt: "Christening 2" },
    { src: "/images/Dbotez/Christening.jpg", alt: "Christening 3" },
    { src: "/images/Dbotez/Christening-7.jpg", alt: "Christening 4" },
    { src: "/images/Dbotez/Christening-9.jpg", alt: "Christening 5" },
    { src: "/images/Dbotez/Christening-11.jpg", alt: "Christening 6" },
    { src: "/images/Dbotez/Christening-15.jpg", alt: "Christening 7" },
    { src: "/images/Dbotez/Christening-4.jpg", alt: "Christening 8" },
    { src: "/images/Dbotez/Christening-5.jpg", alt: "Christening 9" },
    { src: "/images/Dbotez/Christening-6.jpg", alt: "Christening 10" },
    { src: "/images/Dbotez/Christening-8.jpg", alt: "Christening 11" },
    { src: "/images/Dbotez/Christening-10.jpg", alt: "Christening 12" },
    { src: "/images/Dbotez/Christening-12.jpg", alt: "Christening 13" },
    { src: "/images/Dbotez/Christening-13.jpg", alt: "Christening 14" },
    { src: "/images/Dbotez/Christening-14.jpg", alt: "Christening 15" }
  ];

  const handleImageClick = (index) => {
    setSelectedImage(index);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const handlePrevImage = () => {
    setSelectedImage((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  const handleNextImage = () => {
    setSelectedImage((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  useEffect(() => {
    if (selectedImage === null) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') handleCloseModal();
      if (e.key === 'ArrowRight') handleNextImage();
      if (e.key === 'ArrowLeft') handlePrevImage();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, images]);

  return (
    <div className="christening-section">
      <Helmet>
        <title>Christening Photography in Bristol | Baby Baptism Photos</title>
        <meta name="description" content="Capture your child's special day with our Christening photography in Bristol. Natural, beautiful baptism photos across South West UK." />
        <meta name="keywords" content="christening photography, baptism photos, Bristol christening photographer, baby baptism photoshoot, South West UK photography" />
        <meta property="og:title" content="Christening Photography in Bristol | Baby Baptism Photos" />
        <meta property="og:description" content="Capture your child's special day with our Christening photography in Bristol. Natural, beautiful baptism photos across South West UK." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://szakacsvisuals.co.uk/services/christening" />
        <link rel="canonical" href="https://szakacsvisuals.co.uk/services/christening" />
      </Helmet>
      <div className="header-img-container">
        <img className="header-img" src="/images/Dbotez/Christening-11.jpg" alt="Christening header" />
        <div className="header-img-overlay">
          <h1 className="header-title-mobile">Christening</h1>
          <p>Capture the joy and significance of your child's Christening with our personalized photography services.</p>
        </div>
      </div>
      <h1 style={{display:'none'}}>Christening</h1>
      <p style={{display:'none'}}>Beautiful Christening photography to capture your child's special day.</p>
      <div className="gallery-grid-christening">
        {images.map((image, index) => (
          <img key={index} className="gallery-img" src={image.src} alt={image.alt} onClick={() => handleImageClick(index)} />
        ))}
      </div>
      {selectedImage !== null && (
        <div className="album-modal-overlay" onClick={handleCloseModal}>
          <div className="album-modal" onClick={(e) => e.stopPropagation()}>
            <button className="album-close-btn" onClick={handleCloseModal}>&times;</button>
            <button className="album-arrow album-arrow-left" onClick={handlePrevImage}>&#8592;</button>
            <img className="album-image" src={images[selectedImage].src} alt={images[selectedImage].alt} />
            <button className="album-arrow album-arrow-right" onClick={handleNextImage}>&#8594;</button>
            <div className="album-indicators">
              {images.map((_, idx) => (
                <button
                  key={idx}
                  className={idx === selectedImage ? 'album-dot active' : 'album-dot'}
                  onClick={() => setSelectedImage(idx)}
                  aria-label={`Go to image ${idx + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      )}
      
      <div className="gallery-cta">
        <h1>Celebrate Your Child's Christening with Beautiful Photography</h1>
        <p>A Christening is a significant milestone in your child's life — let's capture it with timeless, natural photos that reflect the joy and meaning of the day. Based in Bristol and serving Wales, Somerset, Gloucestershire, and the South West UK, we offer relaxed, family-focused Christening sessions that feel authentic and effortless.

Whether you're planning a traditional church ceremony, a private baptism, or a celebration with family and friends, we'll help you create stunning images that capture the special moments and emotions of the day — from the ceremony itself to family portraits and candid moments.

Let's turn this meaningful occasion into memories that will be treasured for generations.</p>
        <Link to="/contact" className="gallery-cta-btn">Book Now</Link>
      </div>
    </div>
  );
}

export default Christening; 